<div class="location-dialog-wrapper" id="field-text-display">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-title-group">
      @if (panelExpand) {
        <button class="header-back-btn" (click)="onClosePanel()" title="Back to saved addresses">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ea580c"
            stroke-width="2.5">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
      } @else {
        <div class="header-icon-box">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ea580c"
            stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
      }
      <div>
        <h2 class="dialog-title">
          {{ panelExpand ? (panelExpand === 1 ? 'Add New Address' : 'Edit Address') : title }}
        </h2>
        <p class="dialog-subtitle">
          {{
            panelExpand
              ? 'Enter your complete delivery address details'
              : 'Select a saved delivery address or add a new one'
          }}
        </p>
      </div>
    </div>
    @if ((addressArray && addressArray.length >= 1 && isServiceArea) || dialogType === 2) {
      <button class="dialog-close-btn" (click)="onClose()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- SAVED ADDRESSES VIEW (Type 1, Not Expanding Form) -->
  @if (dialogType === 1 && !panelExpand && !loadContainer) {
    <div class="addresses-scroll-container">
      @if (addressArray && addressArray.length) {
        <div class="address-cards-grid">
          @for (idx of addressArray; track idx) {
            <div
              class="address-card"
              [class.is-selected]="data.selectAddress === idx._id"
              (click)="onChangeAddress(idx)">
              <div class="address-card-header">
                <div class="type-and-radio">
                  <div class="custom-radio" [class.checked]="data.selectAddress === idx._id">
                    <div class="radio-dot"></div>
                  </div>
                  <span class="type-badge" [attr.data-type]="idx.addressType || 'Home'">
                    <span class="type-icon">{{
                      (idx.addressType || 'Home') === 'Home'
                        ? '🏠'
                        : (idx.addressType || 'Home') === 'Office'
                          ? '🏢'
                          : '📍'
                    }}</span>
                    {{ idx.addressType || 'Home' | uppercase }}
                  </span>
                  @if (idx.default) {
                    <span class="default-badge">DEFAULT</span>
                  }
                </div>
                <div class="address-card-actions" (click)="$event.stopPropagation()">
                  <button
                    class="action-icon-btn edit-btn"
                    (click)="onEdit(idx)"
                    title="Edit address">
                    <mat-icon>edit</mat-icon>
                  </button>
                  @if (addressArray && addressArray.length > 1) {
                    <button
                      class="action-icon-btn delete-btn"
                      (click)="onDelete(idx._id)"
                      title="Delete address">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  }
                </div>
              </div>

              <div class="address-card-body">
                <div class="recipient-row">
                  <span class="recipient-name">{{ idx.fullName }}</span>
                  <span class="recipient-phone">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#64748b"
                      stroke-width="2">
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    {{ idx.phoneNumber }}
                  </span>
                </div>
                <div class="address-lines-row">
                  <span class="street-address"
                    >{{ idx.houseNo ? idx.houseNo + ', ' : '' }}{{ idx.city
                    }}{{ idx.pinCode ? ' - ' + idx.pinCode : '' }}</span
                  >
                  @if (idx.locality || idx.landmark) {
                    <span class="landmark-accent"
                      >{{ idx.locality ? idx.locality + ', ' : ''
                      }}{{ idx.landmark ? idx.landmark : '' }}</span
                    >
                  }
                </div>
              </div>
            </div>
          }

          <!-- Dashed Add New Address Card -->
          <div class="add-address-card" (click)="onCreate()">
            <div class="add-icon-circle">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ea580c"
                stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="16"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </div>
            <div class="add-text-group">
              <h4 class="add-title">Add New Address</h4>
              <p class="add-sub">Add a new delivery address</p>
            </div>
            <div class="add-arrow">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                stroke-width="2.5">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Actions Footer -->
    <div class="dialog-footer">
      <button class="btn-secondary" (click)="onCreate()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        <span>Add New Address</span>
      </button>
      @if (addressArray.length && data.selectAddress) {
        <button class="btn-primary" (click)="onSubmit()">
          <span>Deliver to this Address</span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      }
    </div>
  }

  <!-- ADD / EDIT ADDRESS FORM (Type 1 Expanding Form) -->
  @if (dialogType === 1 && panelExpand && !loadContainer) {
    <div class="form-container">
      <div class="form-grid">
        <!-- Left: Form inputs -->
        <div class="form-fields-column">
          <div class="form-row">
            <div class="form-field">
              <label>Full Name <span class="required">*</span></label>
              <input type="text" placeholder="Enter full name" [(ngModel)]="data.fullName_text" />
            </div>
            <div class="form-field">
              <label>Phone Number <span class="required">*</span></label>
              <input
                type="number"
                min="0"
                placeholder="10-digit mobile number"
                [(ngModel)]="data.phoneNumber_text"
                (keypress)="isMobValid()" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>Pin Code <span class="required">*</span></label>
              <input
                type="number"
                min="0"
                placeholder="6-digit pin code"
                [(ngModel)]="data.pinCode_text"
                (keypress)="isPinValid()" />
            </div>
            <div class="form-field">
              <label>City / District / Town <span class="required">*</span></label>
              <input
                type="text"
                placeholder="City or Town"
                [(ngModel)]="data.cityDistrictTown_text" />
            </div>
          </div>

          <div class="form-field">
            <label>House No. / Building / Flat <span class="required">*</span></label>
            <input
              type="text"
              placeholder="Flat no., building name, floor"
              [(ngModel)]="data.houseNo_text" />
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>Locality / Area / Street</label>
              <input
                type="text"
                placeholder="Area name or street"
                [(ngModel)]="data.locality_text" />
            </div>
            <div class="form-field">
              <label>Landmark</label>
              <input
                type="text"
                placeholder="Nearby landmark (optional)"
                [(ngModel)]="data.landmark_text" />
            </div>
          </div>

          <div class="address-type-selection">
            <label class="section-label">Save Address As</label>
            <div class="type-pills-group">
              @for (idx of addressTypeArray; track idx) {
                <button
                  type="button"
                  class="type-pill-btn"
                  [class.active]="data.selectAddressType === idx.value"
                  (click)="data.selectAddressType = idx.value">
                  <span>{{
                    idx.value === 'Home' ? '🏠' : idx.value === 'Office' ? '🏢' : '📍'
                  }}</span>
                  <span>{{ idx.name }}</span>
                </button>
              }
            </div>
          </div>

          <div class="default-checkbox-wrapper">
            <mat-checkbox [(ngModel)]="data.selectDefault" color="primary">
              Make this my default delivery address
            </mat-checkbox>
          </div>
        </div>

        <!-- Right: Map preview -->
        <div class="form-map-column">
          <div class="map-wrapper" [fxShow]="!updateLocation" id="map"></div>
          <div class="map-denied-box" [fxShow]="updateLocation">
            <div class="denied-icon">📍</div>
            <h4>Location Access Denied</h4>
            <p>Please enable location permissions in your browser to pin address accurately.</p>
          </div>
          @if (data.latitude_text && data.longitude_text) {
            <div class="coords-tag">
              <span
                >📍 Coordinates: {{ data.latitude_text | number: '1.4-4' }},
                {{ data.longitude_text | number: '1.4-4' }}</span
              >
            </div>
          }
        </div>
      </div>

      <!-- Form Actions Footer -->
      <div class="dialog-footer form-footer">
        <button class="btn-secondary" (click)="onClosePanel()">
          <span>Cancel</span>
        </button>
        <button class="btn-primary" [disabled]="updateLocation" (click)="onSaveAddress()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <span>Save Address</span>
        </button>
      </div>
    </div>
  }

  <!-- OFFLINE / GUEST FORM (Type 2) -->
  @if (dialogType === 2 && !loadContainer) {
    <div class="form-container">
      <div class="form-grid">
        <div class="form-fields-column">
          <div class="form-row">
            <div class="form-field">
              <label>Full Name <span class="required">*</span></label>
              <input type="text" placeholder="Enter full name" [(ngModel)]="data.fullName_text" />
            </div>
            <div class="form-field">
              <label>Pin Code <span class="required">*</span></label>
              <input
                type="number"
                min="0"
                placeholder="6-digit pin code"
                [(ngModel)]="data.pinCode_text"
                (keypress)="isPinValid()" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label>House No. / City / Town <span class="required">*</span></label>
              <input
                type="text"
                placeholder="House no., city"
                [(ngModel)]="data.cityDistrictTown_text" />
            </div>
            <div class="form-field">
              <label>Landmark</label>
              <input type="text" placeholder="Landmark" [(ngModel)]="data.landmark_text" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label>Phone Number <span class="required">*</span></label>
              <input
                type="number"
                min="0"
                placeholder="Phone number"
                [(ngModel)]="data.phoneNumber_text"
                (keypress)="isMobValid()" />
            </div>
            <div class="form-field">
              <label>Address Type</label>
              <div class="type-pills-group">
                @for (idx of addressTypeArray; track idx) {
                  <button
                    type="button"
                    class="type-pill-btn"
                    [class.active]="data.selectAddressType === idx.value"
                    (click)="data.selectAddressType = idx.value">
                    <span>{{ idx.name }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
          <div class="default-checkbox-wrapper">
            <mat-checkbox [(ngModel)]="data.selectDefault" color="primary"
              >Set as Default</mat-checkbox
            >
          </div>
        </div>
        <div class="form-map-column">
          <div class="map-wrapper" [fxShow]="!updateLocation" id="map"></div>
          <div class="map-denied-box" [fxShow]="updateLocation">
            <div class="denied-icon">📍</div>
            <h4>Location Access Denied</h4>
            <p>Please enable location permissions in browser settings.</p>
          </div>
        </div>
      </div>
      <div class="dialog-footer form-footer">
        <button class="btn-primary" [disabled]="updateLocation" (click)="onSaveAddress()">
          <span>Save Address</span>
        </button>
      </div>
    </div>
  }

  <!-- NOT SERVICEABLE / LOAD CONTAINER STATE -->
  @if (loadContainer) {
    <div class="service-error-container">
      <div class="error-graphic-box">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ef4444"
          stroke-width="1.8">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h3>Location Not Serviceable</h3>
      <p>
        We currently do not deliver to this location. Please choose or add an address in our
        delivery service area.
      </p>
      <div class="dialog-footer">
        <button class="btn-primary" [disabled]="updateLocation" (click)="onUpdateAddress()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          <span>Add New Address</span>
        </button>
      </div>
    </div>
  }
</div>
